var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("inline-prompt", {
    staticClass: "d-inline-block bold text-gray ml-2",
    attrs: {
      "action-type": "delete",
      "confirmation-text": _vm.$t("application.messages.allDataWillBeLost"),
    },
    on: {
      accept: function ($event) {
        return _vm.$emit("delete", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }